export default class Role {
  constructor (id, description, name, permissionsIds) {
    this.id = id
    this.description = description
    this.name = name
    this.permissionsIds = permissionsIds
  }
}